import { update } from '../utils/httpUtil'

// update profile
export const editProfileData = (data) => update(`Account/profile`, data)

export const approvalServiceCancellation = (data) => update(`SalesRep/${data.companyId}/Cancellations/Approvals`, data)
